function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M45.043 27.755h64.944V45.12H45.043zM45.043 55.352h64.944v17.365H45.043zM45.043 82.948h64.944v17.365H45.043zM17.944 27.755H35.31V45.12H17.944zM17.944 55.352H35.31v17.365H17.944zM17.944 82.948H35.31v17.365H17.944z",
    className: "icon_svg__black",
    style: {
      fill: "#598b0e"
    }
  }));
};
export default SvgIcon;